import {Component, Input} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {Subscription} from "rxjs";
import {ReportService} from "../../../../services/report.service";
import {Company} from "../../../../interfaces/company.interface";

@Component({
  selector: 'app-background',
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }), // start with opacity 0
        animate('0.7s ease-out', style({ opacity: 1 })) // animate to opacity 1 over 1 second with ease-out timing
      ]),
    ]),
  ]
})
export class BackgroundComponent {

  @Input() edit: boolean | undefined;
  @Input() reportSearch: any;
  @Input() company: Company;

  careerLength:any = 2;
  educationLength:any = 2;
  openMoreCareer:boolean = false
  openMoreEducation:boolean = false

  reportSubscription: Subscription;
  report: any;

  constructor(private reportService: ReportService) {
    this.reportSubscription = reportService.report$.subscribe(
      report => {
        this.report = report;
      });
  }

  showCareer(openMoreCareer: any, length: any) {
    this.openMoreCareer = openMoreCareer
    this.careerLength = length
  }
  showEducation(openMoreEducation: any, length: any) {
    this.openMoreEducation = openMoreEducation
    this.educationLength = length
  }

  /*
  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/human.svg'; // Fallback image when error occurs
  }
  */

  private hasFailedOnce = new Set<string>();
  onImageError(event: Event, item: any) {
    const imgElement = event.target as HTMLImageElement;

    if (!this.hasFailedOnce.has(item.logo_url)) {
      this.hasFailedOnce.add(item.logo_url);
      imgElement.src = 'assets/images/human.svg';
    } else {
      imgElement.style.display = 'none';
    }
  }

  career(length) {
    try {
      return this.report.search_person.job_history?.slice(0, length);
    } catch(error) {
      return 0;
    }
  }
  education(length){
    try {
      return this.report.search_person.education_history?.slice(0, length);
    } catch (error) {
      return 0;
    }
  }
  readMoreCareer()
  {
    try {
      return this.report.search_person.job_history?.length - 2 > 0 && !this.openMoreCareer
    } catch(error) {
      return 0;
    }
  }

  readMoreEducation()
  {
    try {
      return this.report.search_person.education_history?.length - 2 > 0 && !this.openMoreEducation
    } catch(error) {
      return 0;
    }
  }
}
